import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ModalBodyComponent, ModalComponent, ModalFooterComponent, ModalFooterAction, ModalHeaderComponent } from '@groundworks/ngx-groundworks-ui';

@Component({
  selector: 'app-remove-availability-modal',
  imports: [ReactiveFormsModule, NgSelectComponent, ModalComponent, ModalHeaderComponent, ModalBodyComponent, ModalFooterComponent],
  templateUrl: './remove-availability-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    ng-select.ng-select-invalid ::ng-deep .ng-select-container {
      border-color: var(--bs-danger);
    }
  `,
})
export class RemoveAvailabilityModalComponent {
  readonly title = signal('Remove Availability');
  private readonly activeModal = inject(NgbActiveModal);
  private readonly fb = inject(FormBuilder);

  readonly reasons = signal<string[]>([]);

  readonly form: FormGroup = this.fb.group({
    reason: [null as string | null, Validators.required],
  });

  readonly submitted = signal(false);

  readonly footerActions = computed<ModalFooterAction[]>(() => [
    {
      label: 'Cancel',
      type: 'outline-secondary',
      action: () => this.cancel(),
    },
    {
      label: 'Remove',
      type: 'danger',
      action: () => this.confirm(),
    },
  ]);

  confirm(): void {
    this.submitted.set(true);
    if (this.form.invalid) return;
    this.activeModal.close(this.form.value.reason as string);
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
